export default "__VITE_ASSET__Dbr89Rim__"